<template>
    <div>
        <h3>Building Survey Request</h3>
        <loader v-if="isLoading" />
        <div class="wrapper">
            <tabs>
                <tab header="Request">
                    <form class="form form-horizontal" v-on:submit.prevent data-vv-scope="survey">
                        <projectHeader v-bind:project="project"></projectHeader>
                        <div class="form-group">
                            <label class="col-md-2 control-label text-label">Survey Name</label>
                            <div class="col-md-4">
                                <input type="text" class="form-control" v-model="surveyDto.surveyName" v-validate="'required'">
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-2 control-label text-label">Estimated Field Dates</label>
                            <div class="col-md-4">
                                <input type="text" class="form-control" v-model="surveyDto.fieldDatesEstimate" v-validate="'required'">
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-2 control-label text-label">Actual Field Dates</label>
                            <div class="col-md-4">
                                <input type="text" class="form-control" v-model="surveyDto.fieldDatesFinal" :disabled="!surveyDto.buildingSurveyId">
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-2 control-label text-label">Survey Description</label>
                            <div class="col-md-10">
                                <textarea class="form-control" rows="6" v-model="surveyDto.surveyDescription" v-validate="'required'"/>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-md-1 col-md-offset-2">
                                <button class="btn btn-primary" v-on:click="saveSurvey">Save</button>
                            </div>
                        </div>
                    </form>
                </tab>                    
                <tab header="Workflow">
                    <div style="margin-top: 20px;">
                        <workflow :workflowId="buildingSurveyWorkflowId" :parentId="buildingSurveyId" ref="workflow" v-on:workflowOnSubmitSuccess="workflowOnSubmitSuccess"></workflow>
                    </div>
                    <div v-if="checkShpoRole" style="margin-top: 20px;">
                        <quickLetter :projectId="project ? project.projectId : null" :buildingSurveyId="buildingSurveyId" 
                        :mediaTypeId="mediaTypeIdBsLetter" :parentId="buildingSurveyId"></quickLetter>
                    </div> 
                    <div>
                        <div style="margin-top: 20px;">
                            <mediaLetter :mediaTypeId="mediaTypeIdBsLetter" :parentId="buildingSurveyId"></mediaLetter>
                        </div>
                    </div>
                </tab>
            </tabs>
        </div>            
    </div>
</template>

<script>
import loggingService from '@/services/util/loggingService'
import buildingSurveyService from '@/services/buildingSurveyService'
import buildingReconFormService from '@/services/buildingReconFormService'
import projectService from '@/services/projectService'
import workflowService from '@/services/workflowService'
import mediaService from '@/services/mediaService'
import roleService from '@/services/roleService.js'
import userService from '@/services/userService.js'
import { mapState } from 'vuex'

import projectHeader from '@/components/ProjectHeader'
import loader from '@/components/Loader'
import workflow from '@/components/Workflow'
import mediaLetter from '@/components/MediaLetter'
import quickLetter from '../components/QuickLetter.vue'
import { tab, tabs } from 'vue-strap'

export default {
    name: 'BuildingSurvey',
    components: {
        projectHeader,
        loader,
        workflow,
        mediaLetter,
        quickLetter,
        tabs,
        tab
    },
    computed: {
        buildingSurveyWorkflowId: function () {
            return workflowService.WorkflowEnum.BuildingSurvey
        },
        buildingSurveyId: function () {
            return this.$route.params.buildingSurveyId
        },
        mediaTypeIdBsLetter: function () {
            return mediaService.mediaType.BuildingSurveyLetter
        },
                // compute current user info
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        }),
        checkShpoRole: function () {
            var shpoRoleList = [
                roleService.RoleEnum.Administrator,
                roleService.RoleEnum.ShpoAdministrator,
                roleService.RoleEnum.ShpoCrApprovingUser,
                roleService.RoleEnum.ShpoCrDataEntryUser,
                roleService.RoleEnum.ShpoRcAdministrator,
                roleService.RoleEnum.ShpoRcApprovingUser,
                roleService.RoleEnum.ShpoRcDataEntryUser
            ]
            return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, shpoRoleList))
        }
    },
    data: function () {
        return {
            isDebug: false,
            isLoading: false,
            surveyDto: {},
            project: {},
            reconFormGridSpec: {
                columns: ['edit', 'fieldNumber', 'historicName', 'createdDate'],
                options: {
                    perPage: 5,
                    perPageValues: [5, 10, 25],
                    headings: {
                        edit: 'View/Edit',
                        fieldNumber: 'Field Number',
                        historicName: 'Historic Name',
                        createdDate: 'Date Created'
                    }
                },
                tableData: []
            }
        }
    },
    mounted () {
        this.loadData()
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'BuildingReconForm', message)
        },
        createSurveyForm () {
            this.surveyDto = {
            }
        },
        loadSurvey (buildingSurveyId) {
            return buildingSurveyService.get(this.$http, buildingSurveyId).then(result => {
                this.surveyDto = result.data
                return result
            })
        },
        loadReconForms (buildingSurveyId) {
            buildingReconFormService.search(this.$http, {buildingSurveyId: buildingSurveyId}, false).then(result => {
                this.reconFormGridSpec.tableData = result.data
            })
        },
        loadProject () {
            if (!this.surveyDto.projectId) {
                this.log('No Survey')
                return Promise.resolve(1)
            }
            this.log('looking for project: ' + this.surveyDto.projectId)
            return projectService.get(this.$http, this.surveyDto.projectId).then(result => {
                this.log('Found project: ' + result.data.projectName)
                this.project = result.data
                return result
            })
        },
        loadData () {
            this.isLoading = true
            var surveyId = this.$route.params.buildingSurveyId
            if (!surveyId) return this.createSurveyForm()
            Promise.all([this.loadSurvey(surveyId), this.loadReconForms(surveyId)]).then(x => {
                this.loadProject().then(y => {
                    this.$refs.workflow.loadData()
                    this.isLoading = false
                    return y
                })
            })
        },
        saveSurvey () {
            buildingSurveyService.put(this.$http, this.surveyDto).then(result => {
                this.log('new surveyId = ' + result.data.id)
                this.$router.push('/BuildingSurvey/' + result.data.id)
                this.loadData()
            })
        },
        workflowOnSubmitSuccess (submitValidationResult) {
            //trigger media letter refresh if letter gen is triggered
            if (submitValidationResult.letterGenTriggered && this.$refs.mediaLetter) {
                this.$refs.mediaLetter.autoRefreshMedia()
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// BuildingSurvey.vue?42fe632e